import TourPage from "@/components/TourPage";

export default function TanzaniaWildlife8Day() {
  return (
    <TourPage
      tourId="tanzania/wildlife-8-day"
      title="8 Days Wildlife Tanzania Safari"
      duration="8 Days / 7 Nights"
      price="Contact for price"
      image="/serengetiwildbeastmigration.png"
      description="This 8-day wildlife safari adventure in Tanzania explores the breathtaking landscapes and incredible wildlife of Selous Game Reserve, Mikumi National Park, and Ruaha National Park."
      itinerary={[
        {
          day: 1,
          title: "Depart to Selous Game Reserve",
          description: "Begin your adventure in Selous Game Reserve.",
          activities: [
            "Pick up from Dar es Salaam and drive to Selous Game Reserve (5-7 hours)",
            "Boat ride at the Rufigi River for a sunset safari"
          ],
          accommodation: "Lodge in Selous",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Excursion at Selous Game Reserve",
          description: "Full day exploring Selous Game Reserve.",
          activities: [
            "Full-day game drive at Selous Game Reserve",
            "Spot elephants, buffaloes, and rare black rhinos"
          ],
          accommodation: "Lodge in Selous",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Community Tour and Transfer to Mikumi Township",
          description: "Experience local culture and travel to Mikumi.",
          activities: [
            "Walking safari and community tour at Selous Game Reserve",
            "Transfer to Mikumi Township"
          ],
          accommodation: "Lodge in Mikumi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Game Drive and Transfer to Ruaha National Park",
          description: "Explore Mikumi and travel to Ruaha.",
          activities: [
            "Game drive at Mikumi National Park",
            "Transfer to Ruaha National Park"
          ],
          accommodation: "Lodge in Ruaha",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Whole Day Ruaha National Park",
          description: "Full day exploring Ruaha National Park.",
          activities: [
            "Full-day game drive at Ruaha National Park",
            "Spot greater and lesser kudu, roan, and sable antelope"
          ],
          accommodation: "Lodge in Ruaha",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Transfer to Mikumi National Park",
          description: "Return to Mikumi for more wildlife viewing.",
          activities: [
            "Transfer to Mikumi National Park",
            "Game drive at Mikumi National Park"
          ],
          accommodation: "Lodge in Mikumi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Whole Day Safari Mikumi National Park",
          description: "Full day exploring Mikumi National Park.",
          activities: [
            "Full-day game drive at Mikumi National Park",
            "Spot giraffes, elephants, buffaloes, and many other antelopes"
          ],
          accommodation: "Lodge in Mikumi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Transfer to Dar es Salaam",
          description: "Return journey to Dar es Salaam.",
          activities: [
            "Transfer back to Dar es Salaam",
            "Drop off at the ferry or airport"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "Park entrance fee",
        "Drinking water",
        "English speaking guide",
        "Transportation",
        "All nights' accommodation and meals",
        "All Meals (Breakfasts, Lunches & Diners)",
        "All Concession fees"
      ]}
      exclusions={[
        "Taxes and insurance cover",
        "Anything not mentioned above",
        "Optional activities",
        "International flights",
        "Beverages",
        "Visa fees, travel, and health insurance",
        "The government imposed an increase in taxes and/or park fees"
      ]}
    />
  );
}
